import React, { useMemo } from 'react'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { buildV3Location, getStableRouteKey } from '../locationUtils'

export default function LayoutOutlet({ component: LayoutComponent }) {
  const location = useLocation()
  const params = useParams()
  const routeKey = getStableRouteKey(location)
  const paramsKey = JSON.stringify(params)
  const v3Location = useMemo(() => buildV3Location(location, params), [routeKey, paramsKey])

  return (
    <LayoutComponent location={v3Location} params={params}>
      <Outlet />
    </LayoutComponent>
  )
}
